export const RECONNECT_PROBE_AFTER_MS = 8_000

export function classifyReconnect(opts: {
  reconnecting: boolean
  roomState: string // LiveKit Room.state
}): 'idle' | 'resume_attempt' | 'full_restart' {
  if (!opts.reconnecting) return 'idle'
  return opts.roomState === 'disconnected' ? 'full_restart' : 'resume_attempt'
}

export function shouldProbeReconnect(opts: {
  reconnecting: boolean
  reconnectingMs: number
  alreadyProbed: boolean
}): boolean {
  return opts.reconnecting && !opts.alreadyProbed && opts.reconnectingMs >= RECONNECT_PROBE_AFTER_MS
}
